import type { FC } from 'react';

import { Link } from '@packages/modules/src/Link/Link';
import { Image } from '@packages/shared/src/ui/Image/Image';
import { Card, CardContent } from '@packages/shared/src/ui/Card/Card';
import type { FragmentType } from '@packages/gql/generated/shopping';
import { unmask } from '@packages/gql/src/betterMasking';
import type { TopCategoryItemFragmentFragmentDoc } from '@packages/gql/generated/shopping/TopCategoryItemFragmentFragmentDoc';

/* GraphQL */ `
  fragment TopCategoryItemFragment on TopCategory {
    displayName
    icon
    urlPath
  }
`;

export type TopCategoryItemProps = {
  /** prop description for storybook args table */
  /** Top category item to render */
  maskedTopCategory: FragmentType<typeof TopCategoryItemFragmentFragmentDoc>;
};

/**
 * TopCategoryItem Card displays an icon and a title for a given category item.
 * */
export const TopCategoryItem: FC<TopCategoryItemProps> = ({ maskedTopCategory }) => {
  const { displayName, urlPath, icon } =
    unmask<typeof TopCategoryItemFragmentFragmentDoc>(maskedTopCategory);
  return (
    <Link href={urlPath} className="no-underline">
      <Card className="h-full pt-3.5 text-center transition-shadow hover:shadow-md">
        {icon && (
          <div className="flex justify-center">
            <Image src={icon} alt={displayName} width={34} height={34} />
          </div>
        )}
        <CardContent className="px-1 py-2">
          <span className="break-normal">{displayName}</span>
        </CardContent>
      </Card>
    </Link>
  );
};
